import React from "react";

export const DevicesContext = React.createContext<any[]>([]);
